<div *ngIf="sourcePost; else unavailableCard"
     class="share-card"
     [class.share-card--compact]="compact"
     [class.share-card--interactive]="isInteractive"
     [class.share-card--preview]="isPreviewMode">
  <ng-container *ngIf="compact; else fullPostCard">
    <div class="share-card__body">
      <app-post-source-header [post]="sourcePost"
                              [showShareState]="false">
      </app-post-source-header>

      <div class="share-card__content"
           *ngIf="sourcePost.content"
           [innerHTML]="(sourcePost.content | truncateOnWord: 140: '...') | sanitizeHtml">
      </div>

      <img *ngIf="primaryImage"
           class="share-card__image"
           [src]="primaryImage | mediaObject"
           alt="shared content preview">
    </div>
  </ng-container>

  <ng-template #fullPostCard>
    <div class="share-card__body">
      <app-post-source-header [post]="sourcePost"
                              [showShareState]="false">
      </app-post-source-header>

      <div class="share-card__content"
           *ngIf="sourcePost.content"
           [innerHTML]="(sourcePost.content | truncateOnWord: 500: sourcePost.content.length > 500 ? '...' : '') | sanitizeHtml">
      </div>

      <app-post-media-grid *ngIf="sourcePost.media?.length"
                           class="share-card__media"
                           [post]="sourcePost"
                           [currentUser]="currentUser"
                           [interactive]="!isPreviewMode">
      </app-post-media-grid>
    </div>
  </ng-template>
</div>

<ng-template #unavailableCard>
  <div class="share-card share-card--unavailable" [class.share-card--compact]="compact">
    <div class="share-card__title">{{ displayTitle }}</div>
    <div class="share-card__subtitle">{{ displaySubtitle }}</div>
  </div>
</ng-template>
